const endpoints = {
    EXCHANGE: '/exchange/$_1/$_2',
}

export default endpoints;
